import { TouristValues } from 'entities/tour/ui/purchase-form-tours/model.ts'
import { DOCUMENT } from 'entities/user/module'

import { IScanDocument } from 'shared/api/scan-document'
import citizenshipStore from 'shared/store/citizenship-store.ts'

export const getPreparedScanData = (data: IScanDocument): TouristValues => {
  const selectedCitizenship = citizenshipStore.citizenshipTour?.find(
    (item) => item.country_name_en === data?.citizenship?.name,
  )

  const preparedData = {
    firstName: data?.first_name || '',
    lastName: data?.last_name || '',
    middleName: data?.middle_name || '',
    gender: data?.gender || '',
    dateOfBirth: data?.date_of_birth || '',
    citizenship: selectedCitizenship?.country_name_ru || '',
    documentType: DOCUMENT.PASSPORT,
    serialDocuments: '',
    documentExpirationDate: '',
  }

  if (data?.document_type === DOCUMENT.PASSPORT) {
    preparedData.serialDocuments = data.id_card_number as string
    preparedData.documentExpirationDate = data.id_card_expire as string
  }

  return preparedData
}
